function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 17.5C6.5 18.0304 6.71074 18.5391 7.08582 18.9142C7.46089 19.2893 7.96957 19.5 8.5 19.5H9.5C10.0304 19.5 10.5391 19.2893 10.9142 18.9142C11.2893 18.5391 11.5 18.0304 11.5 17.5C11.5 16.9696 11.2893 16.4609 10.9142 16.0858C10.5391 15.7107 10.0304 15.5 9.5 15.5C10.0304 15.5 10.5391 15.2893 10.9142 14.9142C11.2893 14.5391 11.5 14.0304 11.5 13.5C11.5 12.9696 11.2893 12.4609 10.9142 12.0858C10.5391 11.7107 10.0304 11.5 9.5 11.5H8.5C7.96957 11.5 7.46089 11.7107 7.08582 12.0858C6.71074 12.4609 6.5 12.9696 6.5 13.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 3.5H1.5C0.947715 3.5 0.5 3.94772 0.5 4.5V22.5C0.5 23.0523 0.947715 23.5 1.5 23.5H22.5C23.0523 23.5 23.5 23.0523 23.5 22.5V4.5C23.5 3.94772 23.0523 3.5 22.5 3.5Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 8.5H23.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 0.5V5.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 0.5V5.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 19.5V11.5L14.5 13.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgScheduling = function SvgScheduling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScheduling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scheduling.82fd55b6.svg";
export { ForwardRef as ReactComponent };